import { useState } from "react"
// import { usePublicSchools, type PublicSchool } from "./api"

const SCHOOL_DESCRIPTION =
  "Grace Foundation Academy is a beacon of hope in the community, dedicated to nurturing young minds and shaping future leaders. With a strong emphasis on values such as integrity, the academy strives to instill these principles in every child."

const SCHOOLS = [
  {
    name: "Grace Foundation Academy",
    image: "/images/pages/school-grace-wide.jpg",
    location: "Port Harcourt, Rivers State",
    description: SCHOOL_DESCRIPTION,
  },
  {
    name: "Super Achiever’s Junior High",
    image: "/images/pages/school-achievers.jpg",
    location: "Port Harcourt, Rivers State",
    description: SCHOOL_DESCRIPTION,
  },
  {
    name: "Saint Merick Primary & Secondary",
    image: "/images/pages/school-saint-tall.jpg",
    location: "Port Harcourt, Rivers State",
    description: SCHOOL_DESCRIPTION,
  },
]

// const SCHOOL_IMAGES = [
//   "/images/pages/school-grace-wide.jpg",
//   "/images/pages/school-achievers.jpg",
//   "/images/pages/school-saint-tall.jpg",
// ]

// function toSchoolCard(school: PublicSchool, index: number) {
//   return {
//     name: school.name,
//     image: SCHOOL_IMAGES[index % SCHOOL_IMAGES.length]!,
//     location: `${school.city}, ${school.state}`,
//     description: `${school.enrollment} students enrolled in this ${school.type} school${school.since ? `, partnered with Redempta since ${school.since}` : ""}.`,
//   }
// }

function LocationIcon({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  )
}

function SchoolCard({ school, compact = false, stacked = false, active = false, revealed = false, featured = false, onActivate }: { school: (typeof SCHOOLS)[number]; compact?: boolean; stacked?: boolean; active?: boolean; revealed?: boolean; featured?: boolean; onActivate?: () => void }) {
  const animationState = !active ? "inactive" : revealed ? "initial" : "active"

  return (
    <article
      onClick={onActivate}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault()
          onActivate?.()
        }
      }}
      tabIndex={0}
      role="button"
      aria-pressed={active}
      className={`school-card school-card--${animationState} ${stacked ? "school-card--stacked" : ""} group relative h-full min-h-[145px] cursor-pointer overflow-hidden rounded-[16px] outline-none sm:rounded-[32px] lg:min-w-0 ${compact ? "school-card--compact lg:h-[352px]" : "lg:h-[484px]"}`}
    >
      <img
        src={school.image}
        alt={school.name}
        className={`${compact ? (active ? "h-[352px]" : "h-[145px]") : "h-56"} w-full object-cover transition-[height,transform] duration-[700ms] ease-out group-hover:scale-105 sm:h-[230px] lg:h-full`}
        loading="lazy"
      />
      <div className={`school-card__overlay ${active ? "bg-black/10" : "bg-black/35"} absolute inset-0`} />

      <div className="school-card__panel pointer-events-none z-10 text-white">
        <div className="school-card__panel-content">
          <h3 className="school-card__title whitespace-nowrap text-sm font-medium sm:text-xl sm:font-semibold lg:text-sm lg:leading-5">{school.name}</h3>
          <div className={`${active && revealed ? "school-card__details--visible" : "school-card__details--hidden"} school-card__details transition-opacity ease-out`}>
            <p className={`${compact && !featured && !active ? "hidden lg:inline-flex" : "inline-flex"} mt-1 items-center gap-1.5 text-xs font-medium sm:text-base sm:font-semibold lg:text-sm`}>
              <LocationIcon className="h-4 w-4 sm:h-5 sm:w-5" />
              {school.location}
            </p>
            <p className={`${compact && !featured && !active ? "hidden lg:block" : ""} ${compact ? "mt-2" : "mt-3"} text-xs font-medium leading-relaxed sm:text-base sm:font-semibold lg:mt-2 lg:text-sm`}>
              {school.description}
            </p>
          </div>
        </div>
      </div>
    </article>
  )
}

export function GraceSchoolCard({ compact = false }: { compact?: boolean }) {
  return <SchoolCard school={SCHOOLS[0]!} compact={compact} active revealed featured />
}

export function SmallSchoolCard({ image, name, compact = false }: { image: string; name: string; compact?: boolean }) {
  return <SchoolCard school={{ image, name, location: "Port Harcourt, Rivers State", description: SCHOOL_DESCRIPTION }} compact={compact} active revealed />
}

/**
 * The 3-school grid shared by the homepage section and the Partner Schools
 * page. On desktop it behaves like an animated accordion: the active school
 * expands to reveal the blurred text panel while the others collapse into
 * vertical labels. On mobile the cards stack like the provided design.
 */
export function SchoolGrid({ compact = false }: { compact?: boolean }) {
  // const { data } = usePublicSchools()
  const [activeIndex, setActiveIndex] = useState(0)
  const [hasInteracted, setHasInteracted] = useState(false)
  const schools = SCHOOLS

  function activateSchool(index: number) {
    if (index === activeIndex) return

    setHasInteracted(true)
    setActiveIndex(index)
  }

  return (
    <div className={`${compact ? "gap-2" : "gap-3"} flex flex-col lg:h-[484px] lg:flex-row lg:gap-2 ${compact ? "lg:h-[352px]" : ""}`}>
      {schools.map((school, index) => (
        <SchoolCard key={school.name} school={school} compact={compact} stacked active={index === activeIndex} revealed={index === 0 && !hasInteracted} featured={index === 0} onActivate={() => activateSchool(index)} />
      ))}
    </div>
  )
}
